import apiZelo from '../backAxiosVendaToken';

let retorno;

export const BuscarCidadeIbge = async ibge => {
    await apiZelo.get(`/cidades/ibge/${ibge}`)
        .then(response => {
            if(response){
                retorno = response;
            } else {
                retorno = { erro: 'parametros errados' };
            }
        })
        .catch(err => {
            retorno = err;
        });

    return retorno;
};
